import { create } from 'zustand';

interface SelectionState {
  selectedIds: string[];
  setSelectedIds: (ids: string[] | ((prev: string[]) => string[])) => void;
  clearSelection: () => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  selectedIds: [],
  setSelectedIds: (ids) => set((state) => ({ 
    selectedIds: typeof ids === 'function' ? ids(state.selectedIds) : ids 
  })),
  clearSelection: () => set({ selectedIds: [] })
})); 